/** 站点品牌名 / 浏览器标题，由 VITE_APP_TITLE 配置 */
export const APP_TITLE =
  (import.meta.env.VITE_APP_TITLE || "").trim() || "XingHui Marketing";
